var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"0 0 50px 0"}},[_c('v-btn',{on:{"click":function($event){return _vm.TEST()}}},[_vm._v(" test ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }